import { render, staticRenderFns } from "./TipoOcorrenciaManage.vue?vue&type=template&id=36a6e832&scoped=true"
import script from "./TipoOcorrenciaManage.vue?vue&type=script&lang=js"
export * from "./TipoOcorrenciaManage.vue?vue&type=script&lang=js"
import style0 from "./TipoOcorrenciaManage.vue?vue&type=style&index=0&id=36a6e832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a6e832",
  null
  
)

export default component.exports